import { render, staticRenderFns } from "./MyCollect.vue?vue&type=template&id=19a072d6&scoped=true&"
import script from "./MyCollect.vue?vue&type=script&lang=js&"
export * from "./MyCollect.vue?vue&type=script&lang=js&"
import style0 from "./MyCollect.vue?vue&type=style&index=0&id=19a072d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a072d6",
  null
  
)

export default component.exports